module.exports = __webpack_public_path__ + "static/img/pubfactory-logo.c11b1893.svg";